<fab-loading-spinner *ngIf="isPageLoading"></fab-loading-spinner>
<mat-dialog-content>

    <h1 class="header">Create New Employee</h1>
    <table>
        <tr>
            <th id="search">Search for Users</th>
            <td>
                <mat-form-field appearance="outline">
                    <input matInput [(ngModel)]="newUser" required (ngModelChange)="onAddMemberChanged()"/>
                    <div *ngIf="peopleSearchResults.length > 0" class="search-results">
                        <div *ngFor="let model of peopleSearchResults" class="row-search-results-row">

                            <mat-card class="search-results-item"
                                      (click)="personSelected(model)"
                                      (keyup)="personSelected(model)">
                                <mat-card-header>
                                    <img mat-card-avatar class="example-header-image"
                                         src="{{getPhoto(model.gmin)}}"
                                         width="auto"
                                         height="auto"
                                         alt=""
                                         (error)="displayDefaultImage($event)"/>
                                    <mat-card-subtitle
                                            class="display-name-header">{{model.displayName}}</mat-card-subtitle>
                                    <mat-card-subtitle>{{model.positionTitle}}</mat-card-subtitle>
                                </mat-card-header>
                            </mat-card>
                        </div>
                    </div>
                </mat-form-field>

            </td>
        </tr>
    </table>

    <form fxLayout="column" fxLayoutAlign="center" (ngSubmit)="submitForm()" #form="ngForm">
        <table>
            <tr>
                <th id="gmin-header">GMIN:</th>
                <td>
                    <mat-form-field appearance="outline">
                            <input matInput id="gmin" [(ngModel)]="employee.gmin" name="gmin"
                                   [value]="populateFormData.gmin"
                                   [required]="!searchedByUser"/>
                    </mat-form-field>
                </td>
            </tr>
            <tr>
                <th id="first-name">First Name:</th>
                <td>
                    <mat-form-field appearance="outline">
                        <input matInput id="firstName" [(ngModel)]="employee.firstName" name="firstName"
                               [value]="populateFormData.firstName" [required]="!searchedByUser"/>
                    </mat-form-field>
                </td>
            </tr>
            <tr>
                <th id="last-name">Last Name:</th>
                <td>
                    <mat-form-field appearance="outline">
                        <input matInput id="lastName" [(ngModel)]="employee.lastName" name="lastName"
                               [value]="populateFormData.lastName" [required]="!searchedByUser"/>
                    </mat-form-field>
                </td>
            </tr>
            <tr>
                <th id="email">Email:</th>
                <td>
                    <mat-form-field appearance="outline">
                        <input matInput id="emailAddress" [(ngModel)]="employee.emailAddress" name="emailAddress"
                               [value]="populateFormData.email" [required]="!searchedByUser"/>
                    </mat-form-field>
                </td>
            </tr>
            <tr>
                <th id="contract-type">Contract Type:</th>
                <td>
                    <mat-form-field appearance="outline">
                        <mat-label>Contract Type:</mat-label>
                        <select matNativeControl [(ngModel)]="employee.contractType" name="contract" required>
                            <option *ngFor="let contract of contractTypes" [value]="contract.value">
                                {{contract.displayValue}}
                            </option>
                        </select>
                    </mat-form-field>
                </td>
            </tr>
            <tr>
                <th id="region-header">Region:</th>
                <td>
                    <mat-form-field appearance="outline">
                        <input matInput id="region" [(ngModel)]="employee.region" name="region"
                               [value]="populateFormData.country" [required]="!searchedByUser"/>
                    </mat-form-field>
                </td>
            </tr>
            <tr>
                <th id="team-header">Team:</th>
                <td>
                    <mat-form-field appearance="outline">
                        <mat-label>Team:</mat-label>
                        <select matNativeControl [(ngModel)]="employee.teamId" name="team" id="team" required>
                            <option *ngFor="let team of teamData" [value]="team.id">
                                {{team.teamName}}
                            </option>
                        </select>
                    </mat-form-field>
                </td>
            </tr>
            <tr>
                <th id="start-date">Start Date:</th>
                <td>
                    <mat-form-field appearance="outline">
                        <mat-label>Enter start date</mat-label>
                        <input matInput [matDatepicker]="picker" [formControl]="date" readonly [required]="!searchedByUser"/>
                        <mat-hint>MM/DD/YYYY</mat-hint>
                        <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
                        <mat-datepicker #picker></mat-datepicker>
                    </mat-form-field>
                </td>
            </tr>
            <tr>
                <th id="role-header">Role:</th>
                <td>
                    <mat-form-field appearance="outline">
                        <select matNativeControl [(ngModel)]="user.roles" name="role" id="role" [required]="!searchedByUser">
                            <option *ngFor="let role of roles; let i = index" [value]="role.value">
                                {{role.displayValue}}
                            </option>
                        </select>
                    </mat-form-field>
                </td>
            </tr>
        </table>
        <button mat-raised-button color="primary" [disabled]="!form.form.valid">Submit</button>
    </form>
</mat-dialog-content>
